import React, { Component } from "react";
import "react-bootstrap";

import $ from "jquery/dist/jquery.js";
import store from "../../store/configureStore";
import Pagination from "../../components/pagination/Pagination";
import ArticleBlock from "./ArticleBlock";
import { lang } from "../../config/lang";
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from "../../actions/topBannerAction";
import { changeActiveItemAction } from "../../actions/navAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import captionApi from "../../api/captionApi";
import leadershipApi from "../../api/leadershipApi";
import ScrollToTop from "../home/ScrollToTop/ScrollToTop";
/****************************************
    Component for revolution page
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/
class LeadershipList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arrArticles: [],
      title: "",
      curPage: 1,
      pages: 0,
      deltaPage: 6,
      business: Businesses.indexOf("revolution"),
    };

    this.load = this.load.bind(this);
  }

  componentWillMount() {
    store.dispatch(changeActiveItemAction(Businesses.indexOf("revolution")));
    store.dispatch(
      changeTopBannerAction({
        page: "",
        showSearch: false,
        isHome: false,
      })
    );
  }

  componentDidMount() {
    this.load();
    window.onClose();
    window.gallery();
    window.onSetClass("dark");
    $("#footer").css("visibility", "hidden");
  }

  componentWillUnmount() {}

  componentDidUpdate() {
    window.onClose();
  }

  componentWillReceiveProps(newProps) {
    this.load(newProps);
  }
  load(newProps) {
    captionApi.getCaptions("revolution").then((json) => {
      if (json.status === 200) {
        var caption =
          json.data[
            CaptionCodes[PagesForCaption.indexOf("revolution")].indexOf(
              "leadership_leadership"
            )
          ];
        this.setState({
          title:
            caption === undefined ||
            caption === null ||
            caption.title === undefined ||
            caption.title === null
              ? ""
              : caption.title,
        });
        // if (newProps.page) this.setState({ page: newProps.page })
      } else {
        store.dispatch(addNotification(`${lang("server_err")}`, "error"));
      }
    });

    leadershipApi.getAll(this.state.curPage - 1).then((json) => {
      let dateArray = [];
      if (json.status === 200 && json.data) {
        json.data.length &&
          json.data.map((one, key) => dateArray.push(one.date));
        this.setState({
          arrArticles: json.data.blog,
          arrDate: dateArray,
          total: json.data.total,
          pages: Math.ceil(json.data.total / 10),
        });
        $("#footer").css("visibility", "visible");
      } else {
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
        }
      }
    });
  }

  onChangePage(page) {
    // eslint-disable-next-line
    this.state.curPage = page;
    this.load();
    window.scrollTop("#activity_section", 100);
  }

  render() {
    return (
      <div>
        <section
          ref="revolution"
          className="ftco-revolution-section revolution"
          id="revolution"
        >
          <hr className="solid tall" />
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="portfolio-title">
                  <div className="row">
                    <div className="col-md-12 caption align-items-center">
                      <h2 className="mb-none" style={{ fontSize: "1.9em" }}>
                        <i className="icon icon-flag"></i>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: "&nbsp;" + this.state.title,
                          }}
                        ></span>
                      </h2>
                      <br />
                      <div className="text-center">
                        {`${lang("total")}` + this.state.total}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="solid tall" />
          <div className="container ftco-animate fadeIn ftco-animated">
            <div className="row">
              <div className="col-md-12 mb-5">
                {this.state.arrArticles.map((singleArticle, key) => (
                  <ArticleBlock
                    key={key}
                    pKey={10 * this.state.curPage + key - 9}
                    business={this.state.business}
                    id={singleArticle.id}
                    title={singleArticle.title}
                    date={singleArticle.date}
                    images={singleArticle.medias}
                  />
                ))}
              </div>
            </div>
            <hr className="solid tall" />
          </div>
          <div className="container">
            <div className="row justify-content-center pb-5">
              <div className="col-md-12 block-27 text-center">
                {
                  <Pagination
                    total={this.state.pages}
                    curPage={this.state.curPage}
                    visible={this.state.deltaPage}
                    onChangePage={(page) => this.onChangePage(page)}
                  />
                }
              </div>
            </div>
          </div>
        </section>
        <ScrollToTop />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
    page: state.page,
  };
}

export default connect(mapStateToProps)(LeadershipList);
